<template>
  <div>
    <div id="myDiv" />
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      y: 0,
      textangle: 0
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      const parserItems = this.$helperPlugin.parserGroupsInValidChartItems(this.items)
      parserItems.annotations.filter(x => x.t === 'originPlace').forEach(x => {
        x.y = -(parserItems.total / parserItems.y.length)
        x.textangle = this.textangle
      })

      const stack = {
        x: parserItems.x,
        y: parserItems.y,
        name: 'Gráfico de Barras',
        type: 'bar',
        textposition: 'inside',
        text: parserItems.texts,
        hoverinfo: 'bottom',
        orientation: 'v',
        measure: ['relative', 'relative', 'relative'],
        connector: { visible: true },
        marker: {
          color: parserItems.colors
        }
      }

      const pie = {
        values: this.items.map(x => x.value),
        labels: this.items.map(x => x.name),
        marker: {
          colors: this.items.map(x => x.color)
        },
        domain: {
          row: 0,
          column: 1
        },
        type: 'pie'
      }

      const data = [
        stack,
        pie,
        ...parserItems.lines
      ]

      const layout = {
        xaxis: {
          type: 'category',
          visible: false,
          showticklabels: false
        },
        yaxis: {
          type: 'linear',
          visible: false,
          showticklabels: true
        },
        autosize: true,
        annotations: parserItems.annotations,
        showlegend: true,
        barmode: 'stack',
        grid: { rows: 1, columns: 2 },
        legend: {
          orientation: 'h',
          yanchor: 'bottom',
          y: 1.06,
          xanchor: 'right',
          x: 1
          // x: 0,
          // y: 1,
          // traceorder: 'normal',
          // font: {
          //   family: 'sans-serif',
          //   size: 12,
          //   color: '#000'
          // },
          // bordercolor: '#FFFFFF',
          // borderwidth: 2
        }
      }
      const config = {
        displaylogo: false,
        scrollZoom: true,
        displayModeBar: true,
        editable: false,
        showLink: false
      }
      const size = 1200
      Plotly.newPlot('myDiv', data, layout, config ).then(gd => { //eslint-disable-line
        Plotly.toImage(gd, { height: size, width: size}) //eslint-disable-line
          .then((url) => {
            this.$emit('setImage', url)
          })
      })
    }
  }
}
</script>

<style scoped>
*{
font-size: 15px !important;
}
</style>
